module.exports = __webpack_public_path__ + "static/media/Slider7.4793ccac.webp";